import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-location';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/tandaBranchLocations`, {
		status: 0,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/tandaBranchLocations/${id}`);
};

const create = (
	merchantId,
	branchId,
	tandaTeamId,
	tandaTeamName,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/tandaBranchLocations`, {
		branchId,
		tandaTeamId,
		tandaTeamName,
		operateBy,
	});
};

const update = (
	merchantId,
	branchId,
	tandaTeamId,
	tandaTeamName,
	operateBy
) => {
	return Client.put(`${baseUrl}/${merchantId}/tandaBranchLocations`, {
		branchId,
		tandaTeamId,
		tandaTeamName,
		operateBy,
	});
};

const remove = (merchantId, branchId, operateBy) => {
	return Client.del(
		`${baseUrl}/${merchantId}/tandaBranchLocations`,
		{},
		{
			branchId,
			operateBy,
		}
	);
};

const locationList = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/tandaLocations`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	locationList,
};
